import React from 'react'

// eslint-disable-next-line react/display-name
export default () => (
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="transparent"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 11.4994H12.25C13.6967 11.5607 14.9231 10.446 15 9.00011V9.00011C14.9238 7.55375 13.6971 6.43852 12.25 6.50011H11"
      fill="transparent"
      stroke="#363A53"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 11.4994H3.75C2.30332 11.5607 1.07689 10.446 1 9.00009V9.00009C1.07654 7.55389 2.30307 6.43886 3.75 6.50009H5"
      fill="transparent"
      stroke="#363A53"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 4.49939V1.49939"
      fill="transparent"
      stroke="#363A53"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 4.49939L5 3.49939"
      stroke="#363A53"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 4.49939L11 3.49939"
      stroke="#363A53"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 13.4994V16.4994"
      stroke="#363A53"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 13.4994L5 14.4994"
      stroke="#363A53"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 13.4994L11 14.4994"
      stroke="#363A53"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
